<template>
  <div class="meta-data">
    <div v-for="(field, index) in metaDataValues"
         :key="index"
         class="form-group meta-data__field">
      <b-form-checkbox v-if="field.inputMethod === 'CHECKBOX'"
                       v-model="field.value"
                       :for="field.fieldId"
                       class="meta-data__input">
        {{ field.label }}
      </b-form-checkbox>

      <div v-else-if="field.inputMethod === 'COMBOBOX'"
           class="meta-data__input">
        <label :for="field.fieldId">
          {{ field.label }}
        </label>
        <b-form-select :id="field.fieldId"
                       v-model="field.value"
                       :options="getComboItems(field)">
        </b-form-select>
      </div>

      <div v-else
           class="meta-data__input">
        <label :for="field.fieldId">
          {{ field.label }}
        </label>
        <b-form-input :id="field.fieldId"
                      v-model="field.value"
                      :type="getTextInputType(field)">
        </b-form-input>
      </div>

      <span v-if="showValidation && field.mandatory && !field.value"
            class="validation-error">
        Please enter {{ field.label }}.
      </span>
    </div>
  </div>
</template>
<script>

import { get, isEqual, cloneDeep } from "lodash";

export default {
  props: {
    /**
     * Meta data configuration to display
     */
    value: {
      type: Array,
      default: () => []
    },

    /**
     * If true then validation messages are shown
     */
    showValidation: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      internalValue: []
    };
  },

  computed: {
    metaDataValues () {
      let result = [];

      if ( this.internalValue && this.internalValue.length > 0 ) {
        result = this.internalValue.filter( m => m.showOnEcommerceSite );
      }

      return result;
    }
  },

  watch: {
    /**
     * When the value is changed, updated our internal data
     */
    value: {
      immediate: true,
      deep: true,
      handler ( val ) {
        if ( !isEqual( val, this.internalValue ) ) {
          this.internalValue = cloneDeep( val );
        }
      }
    },

    /**
     * When the internal data is changed, emit it to the parent
     */
    internalValue: {
      deep: true,
      handler ( val ) {
        this.$emit( "input", val );
      }
    }
  },

  methods: {
    /**
     * For text box fields, work out what the field type should be
     *
     * @param {object} field The meta data field configuration
     */
    getTextInputType ( field ) {
      let type = null;
      const dataType = get( field, "dataType", "string" ).toLowerCase();

      switch ( dataType ) {
        case "int": {
          type = "number";
          break;
        }
        default: {
          type = "text";
          break;
        }
      }

      return type;
    },

    /**
     * For combo fields, get a list of items to display
     *
     * @param {object} field The meta data field configuration
     */
    getComboItems ( field ) {
      // Add a default "Please select item"
      const items = [{
        value: "",
        text: "-- Please select --"
      }];

      // Add the rest of the lookup values (these are stored as a dictionary on the
      // field object)
      const lookupValues = get( field, "lookupValues", null );
      if ( lookupValues ) {
        Object.entries( lookupValues ).forEach( ( [key, value] ) => {
          items.push( {
            value: key,
            text: value
          } );
        } );
      }

      return items;
    }
  }
};
</script>
